import { Box, Typography } from '@mui/material'
import { FlagsIconSeeker, IconSeeker } from '@ui-seeker/core'
import { translateCountryName } from '@ui-seeker/utils'
import React from 'react'

export default function officeDataColumn() {

	const officeTypeMapping = {
		airport: 'Airport',
		downtown: 'City',
		truck: 'Trucks',
		train_station: 'Train Station',
	}
	const icon = {
		airport: 'plane-departure',
		downtown: 'city',
		truck: 'truck',
		train_station: 'train',
	}

	return [ {
		name: 'officeData',
		label: 'Office Type',
		options: {
			display: 'excluded',
			customBodyRowRender: ({ type }) => officeTypeMapping[type],
		},
	}, {
		name: 'officeData',
		label: 'Office Name',
		options: {
			display: 'excluded',
			filterType: 'textField',
			customBodyRowRender: ({ name }) => name,
		},
	}, {
		name: 'officeData',
		label: 'Office Country',
		options: {
			display: 'excluded',
			customBodyRowRender: ({ country }) => translateCountryName(country),
		},
	}, {
		name: 'officeData',
		label: 'Office',
		options: {
			filter: false,
			headerAlign: 'left',
			customBodyRowRenderLite: ({ name, type, country }) => (
				<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start', gap: 1 }}>
					<FlagsIconSeeker countryName={country}/>
					<IconSeeker icon={icon[type]}/>
					<Typography sx={{ fontWeight: 'bold' }}>{name}</Typography>
				</Box>
			),
		},
	} ]
}
